// extracted by mini-css-extract-plugin
export default {"alert":"custom-alert-cc_styles_component_alert__28DuS"};